import { withTheme, css } from 'styled-components'
import { Box } from 'rebass'
import { height, width } from 'styled-system'
import Text from './Text'

const Checkbox = withTheme(props => {
  let { onChange, id, ...rest } = props
  return (
    <Box
      {...rest}
      css={[
        `
        margin: -1px 0 0 0;
        display: inline-block;
        transition: box-shadow .1s`,
        width,
        height
      ]}>
      <Text {...rest} onChange={onChange} as={'input'} type={'checkbox'} css={[`display:none;`]} id={id} />
      <Box
        {...rest}
        css={[
          `
            cursor: pointer;
            vertical-align: middle;
            font-size: 14px;
            font-family: "zen-icomoon";
            font-weight: 1;
            border-radius: 2px;
            `,
          props => css`
            background-color: ${props.theme.colors.primary};
            :before {
              content: '\\e915';
              background-color: #ffffff;
              color: ${props.error ? props.theme.colors.red.default : '#d5d6d7'};
            }
          `,
          props =>
            props.checked
              ? css`
                  box-shadow: '0 1px 2px rgba(${props.theme.colors.primary}, 0.5)';
                  :before {
                    content: "\\e947";
                    color: #ffffff;
                    background-color:transparent;
                  }
                `
              : css`
              background-color: transparent;
              `
        ]}
      />
    </Box>
  )
})

export default Checkbox
